import { baseURL } from "@/requestErrorConfig";
import { request } from "@umijs/max";
import axios, { AxiosRequestConfig } from "axios"


const instance = axios.create({
    baseURL: baseURL,
    withCredentials: true
})

axios.defaults.withCredentials = true

export const apiRequest = async <T>(
    url: string,
    method: 'GET' | 'POST',
    body?: any,
    options?: { [key: string]: any },
): Promise<T> => {
    const config: AxiosRequestConfig = {
        url,
        method,
        headers: body instanceof FormData ? undefined : {
            'Content-Type': 'application/json',
        },
        ...(body ? { data: body } : {}),
        ...(options || {}),
    };
    console.log(config, instance)
    if (method == "GET") {
        const repsonse = await instance.get<T>(url);
        return repsonse.data;
    } else {
        const repsonse = await instance.post<T>(url, body);
        return repsonse.data;
    }

};
export const download = async <T>(
    url: string,
): Promise<T> => {

    const repsonse = await instance.request<T>({
        url,
        method: "GET",
        responseType: 'arraybuffer'
    });
    return repsonse.data;
};